import React from 'react';

/**
 * The three totals above My Tasks, from orders/assigned/count.
 */
const MyTasksCounts = ({ counts }) => {
  if (!counts) {
    return null;
  }

  const cards = [
    { key: 'total', label: 'Assigned orders', value: counts.totalAssignedOrders },
    { key: 'overdue', label: 'Overdue orders', value: counts.totalOverdueOrders },
    { key: 'on-time', label: 'Not overdue', value: counts.totalNotOverdueOrders },
  ];

  return (
    <div className="my-tasks-counts">
      {cards.map((card) => (
        <div className={`my-tasks-count card ${card.key}`} key={card.key}>
          <span className="count-value">{card.value ?? 0}</span>
          <span className="count-label">{card.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MyTasksCounts;
